export default class MortgageCalculator {
    constructor() {

        this.amountInput = document.getElementById('amount-input')
        this.interestRateInput = document.getElementById('interest-rate-input')
        this.lengthOfLoanInput = document.getElementById('length-of-loan-input')
        this.calculateBtn = document.getElementById('calculate-btn')
        this.resetBtn = document.getElementById('reset-btn')
        this.mortgageFinalResult = document.getElementById('mortgage-final-result')

        this.init();
    }

    init() {

        const errorMessage = 'Please check the values entered are correct'

        this.amountInput.addEventListener('focusout', (e) => {
            if (!this.amountInput.validity.valid) {
                this.amountInput.classList.add('error')
            } else {
                this.amountInput.classList.remove('error');
            }
        })

        this.interestRateInput.addEventListener('focusout', (e) => {
            if (!this.interestRateInput.validity.valid) {
                this.interestRateInput.classList.add('error')
            } else {
                this.interestRateInput.classList.remove('error');
            }
        })

        this.lengthOfLoanInput.addEventListener('focusout', (e) => {
            if (!this.lengthOfLoanInput.validity.valid) {
                this.lengthOfLoanInput.classList.add('error')
            } else {
                this.lengthOfLoanInput.classList.remove('error');
            }
        })

        this.calculateBtn.addEventListener('click', (e) => {
            if (this.amountInput.validity.valid && this.interestRateInput.validity.valid && this.lengthOfLoanInput.validity.valid) {
                this.calculate()
            } else {
                this.mortgageFinalResult.textContent = errorMessage
                this.mortgageFinalResult.classList.add('error-message')
                this.calculateBtn.classList.add('form-error')
                if (!this.amountInput.validity.valid) {
                    this.amountInput.classList.add('error')
                }
                if (!this.interestRateInput.validity.valid) {
                    this.interestRateInput.classList.add('error')
                }
                if (!this.lengthOfLoanInput.validity.valid) {
                    this.lengthOfLoanInput.classList.add('error')
                }
            }
        })

        this.resetBtn.addEventListener('click', () => {
            this.resetBtn.style.display = 'none'
            this.mortgageFinalResult.textContent = ''
            this.calculateBtn.removeAttribute('disabled')
            this.calculateBtn.classList.remove('form-success')
        })

        // Attach the listeners
        // document.querySelectorAll('input').forEach((el) => {
        //     el.addEventListener('keydown', (e) => { this.fillBuffer(e) });
        //     el.addEventListener('keyup', (e) => { this.fillBuffer(e) } );
        // });
    }

    calculate() {
        const borrowedMoney = this.amountInput.value
        const lengthOfLoan = this.lengthOfLoanInput.value * 12
        const interestRate = this.interestRateInput.value
        const calculedInterest = interestRate / 100
        const interestPercentage = calculedInterest / 12

        const percentage = interestPercentage; // 0.065 / 12 = 6.5% / 12
        const percentagePlusOne = interestPercentage + 1
        const exponentiationOperator = (percentagePlusOne ** lengthOfLoan)
        const firstDividend = percentage * exponentiationOperator;
        const secondDividend = exponentiationOperator - 1
        const division = firstDividend / secondDividend
        const mortgage = borrowedMoney
        const quotas = mortgage * division

        const successMessage = 'Your monthly payments: '

        this.mortgageFinalResult.innerHTML = `<span class="mortgage-form__success-text">${successMessage}</span> <span class=" mortgage-form__success-price">£${quotas.toFixed(2)}</span>`
        this.mortgageFinalResult.classList.remove('error-message')
        this.mortgageFinalResult.classList.add('success-message')
        this.calculateBtn.classList.add('form-success')
        // this.calculateBtn.setAttribute('disabled', 'disabled')
        this.resetBtn.style.display = 'block'
    }

    fillBuffer(e) {
        console.log(e.target.value.length);
        // Clear the buffer if input gets wiped
        if (e.target.value.length === 0) {
            e.target.parentElement.querySelector('.suffix span').textContent = "";
            return;
        }

        // Using a filler char will prevent the suffix to be overwritten with the input
        const extraFiller = e.target.value.length ? '' : '';

        e.target.parentElement.querySelector('.suffix span').textContent = e.target.value + extraFiller;
    }

}

new MortgageCalculator;